import { Call, CallAndPhoto } from "../models/call.model";
import { UuidAndId } from "../models/uuid-and-id";
import { CallStateModel } from "../state/call.state";

export namespace CallActions {
    export class Refresh {
        static readonly type = '[API-SURVEY] Refresh'
        constructor() {}
    }
    export class IncrementPendingCount {
        static readonly type = '[Network Service-SURVEY] Increment Pending Count'
        constructor() {}
    } 
    export class Init {
        static readonly type = '[Storage-SURVEY] Init'
        constructor(public payload: CallStateModel) {}
    }
    export class Set {
        static readonly type = '[API-SURVEY] Set'
        constructor(public payload: Call[]) {}
    }
    export class Merge {
        static readonly type = '[API-SURVEY] Merge'
        constructor(public payload: Call[]) {}
    }
    export class AddOne {
        static readonly type = '[UI-SURVEY] Add One'
        constructor(public payload: Call) {}
    }    
    export class UpdateOne {
        static readonly type = '[UI-SURVEY] Update One'
        constructor(public payload: Call) {}
    }       
    export class DeleteOne {
        static readonly type = '[UI-SURVEY] Delete One'
        constructor(public payload: Call) {}
    }     
    export class ApiAddedOne {
        static readonly type = '[API-SURVEY] Added One'
        constructor(public payload: Call) {}
    }
    export class ApiUpdatedOne {
        static readonly type = '[API-SURVEY] Updated One'
        constructor(public payload: Call) {}
    }
    export class ApiDeletedOne {
        static readonly type = '[API-SURVEY] Deleted One'
        constructor(public payload: UuidAndId) {}
    }
    export class AddPhotoToCall {
        static readonly type = '[UI-SURVEY] Add Photo To Call'
        constructor(public payload: CallAndPhoto) {}
    }
    export class DeletePhotoFromCall {
        static readonly type = '[UI-SURVEY] Delete Photo From Call'
        constructor(public payload: CallAndPhoto) {}
    }
    export class ApiAddedPhotoToCall {
        static readonly type = '[API-SURVEY] Added Photo To Call'
        constructor(public payload: CallAndPhoto) {}
    }
    export class ApiDeletedPhotoFromCall {
        static readonly type = '[API-SURVEY] Deleted Photo From Call'
        constructor(public payload: CallAndPhoto) {}
    }
    export class ApiStartUploading {
        static readonly type = '[API-SURVEY] Start Uploading Photo'
        constructor(public payload: CallAndPhoto) {}
    }
    export class ApiStopUploading {
        static readonly type = '[API-SURVEY] Stop Uploading Photo'
        constructor(public payload: CallAndPhoto) {}
    }
}
